import { useHistory, useParams } from 'react-router-dom';
import useRoutes from '../../../../hooks/useRoutes';
import { useLayoutEditorContext } from '../../../../hooks/context/useLayoutEditorContext';
import { LayoutEditorFullscreenReference } from '../../../../types/context';
import { FullscreenReferenceType } from '../../../../types/types';

// Opens the fullscreen reference picker of a layout editor field: the picker
// state goes into the layout editor context (it stays mounted — the editor
// route matches the reference URL too) and the app navigates to the reference
// route. Shared by the panel sections and the matrix dialog.
export const useFullscreenReferenceNavigation = () => {
  const history = useHistory();
  const routes = useRoutes();
  const { datasetId, layoutId, objectId } = useParams<{
    datasetId: string;
    layoutId: string;
    objectId?: string;
  }>();
  const { openFullscreenReference } = useLayoutEditorContext();

  const openFullscreenReferenceRoute = (
    reference: FullscreenReferenceType,
    scope: LayoutEditorFullscreenReference['scope']
  ): void => {
    if (!objectId) {
      return;
    }

    openFullscreenReference(reference, scope);
    history.push(
      routes.layoutEditorReference(
        datasetId,
        layoutId,
        objectId,
        reference.name
      )
    );
  };

  return { openFullscreenReferenceRoute };
};
